// extracted by mini-css-extract-plugin
export var buttonContainer = "_6q-1";
export var fontSizeSelect = "_6q-3";
export var formatSelect = "_6q-2";
export var formats = "_6q-4";
export var hidden = "_6q-5";
export var icon = "_6q-6";
export var select = "_6q-0";